import { useState } from "react";
import { X, DownloadSimple } from "@phosphor-icons/react";
import { isNative } from "../lib/native";

const STORE = {
  ios: "https://apps.apple.com/us/app/aluga-j%C3%A1/id6784399940",
  android: "https://play.google.com/store/apps/details?id=com.alugaja.app&hl=pt_BR",
};
const DISMISS_KEY = "aj_smartbanner_dismissed_at";
const DISMISS_DAYS = 7;

function detectPlatform() {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/Android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/i.test(ua) || (/Macintosh/i.test(ua) && "ontouchend" in document)) return "ios";
  return null;
}

function recentlyDismissed() {
  try {
    const ts = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return ts && Date.now() - ts < DISMISS_DAYS * 86400000;
  } catch { return false; }
}

/** Smart App Banner (web-only): direciona quem acessa pelo navegador mobile para a loja correta. */
export default function SmartAppBanner() {
  const [platform] = useState(detectPlatform);
  const [hidden, setHidden] = useState(recentlyDismissed);

  // Só na web (nunca dentro do app nativo) e apenas em navegador mobile (iOS/Android).
  if (isNative() || !platform || hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* noop */ }
    setHidden(true);
  };

  const storeUrl = STORE[platform];
  const storeName = platform === "ios" ? "App Store" : "Google Play";

  return (
    <div
      className="bg-white border-b border-slate-200 shadow-sm"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      data-testid="smart-app-banner"
    >
      <div className="flex items-center gap-2.5 px-3 py-2">
        <button onClick={dismiss} className="p-1 text-slate-400 shrink-0" aria-label="Fechar" data-testid="smart-app-banner-close">
          <X size={18} weight="bold" />
        </button>
        <img src="/icon-192.png" alt="AlugaJá" className="w-10 h-10 rounded-xl object-contain shrink-0" />
        <div className="min-w-0 flex-1 leading-tight">
          <div className="font-black text-[#0F172A] text-sm">
            Aluga<span className="text-[#FF6B35]">Já</span>
          </div>
          <div className="text-[11px] text-slate-500 truncate">Baixe grátis na {storeName} — mais rápido e com notificações.</div>
        </div>
        <a
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={dismiss}
          className="ml-auto shrink-0 inline-flex items-center gap-1.5 bg-[#004E98] text-white font-bold text-xs px-3.5 py-2 rounded-full active:scale-95 transition-transform"
          data-testid="smart-app-banner-cta"
        >
          <DownloadSimple size={15} weight="bold" /> Abrir
        </a>
      </div>
    </div>
  );
}
